<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('maquinarias')">Combustible</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Precios-
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.gasolinera" :error="form.errors.gasolinera" class="pr-6 pb-8 w-full lg:w-1/4" label="Gasolinera" required>
            <option value="5">Cofiza</option> 
            <option value="1">Henay</option>
            <option value="2">Trasn. Esmeraldas</option>
            <option value="3">Primax</option>
            <option value="4">Super Parada Tsáchila</option>
            <option value="4">San Pio</option>
          </select-input>  
          <div v-if="form.gasolinera==1">
          <text-input v-model="form.diesel_1" :error="form.errors.diesel_1" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_1" :error="form.errors.extra_1" class="pr-6 pb-8 w-full lg:w-4/4" label="extra" required/>
         
          <text-input v-model="form.super_1" :error="form.errors.super_1" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div>  
        <div v-if="form.gasolinera==2">
          <text-input v-model="form.diesel_2" :error="form.errors.diesel_2" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_2" :error="form.errors.extra_2" class="pr-6 pb-8 w-full lg:w-4/4" label="extra" required/>
         
          <text-input v-model="form.super_2" :error="form.errors.super_2" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div> 
        <div v-if="form.gasolinera==3">
          <text-input v-model="form.diesel_3" :error="form.errors.diesel_3" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_3" :error="form.errors.extra_3" class="pr-6 pb-8 w-full lg:w4-4/4" label="extra" required/>
         
          <text-input v-model="form.super_3" :error="form.errors.super_3" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div> 
        <div v-if="form.gasolinera==4">
          <text-input v-model="form.diesel_4" :error="form.errors.diesel_4" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_4" :error="form.errors.extra_4" class="pr-6 pb-8 w-full lg:w-4/4" label="extra" required/>
         
          <text-input v-model="form.super_4" :error="form.errors.super_4" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div> 
        <div v-if="form.gasolinera==5">
          <text-input v-model="form.diesel_5" :error="form.errors.diesel_5" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_5" :error="form.errors.extra_5" class="pr-6 pb-8 w-full lg:w-4/4" label="extra" required/>
         
          <text-input v-model="form.super_5" :error="form.errors.super_5" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div> 
        <div v-if="form.gasolinera==6">
          <text-input v-model="form.diesel_6" :error="form.errors.diesel_6" class="pr-6 pb-8 w-full lg:w-4/4" label="diesel" required/>
          
          <text-input v-model="form.extra_6" :error="form.errors.extra_6" class="pr-6 pb-8 w-full lg:w-4/4" label="extra" required/>
         
          <text-input v-model="form.super_6" :error="form.errors.super_6" class="pr-6 pb-8 w-full lg:w-4/4" label="super" required/>
        </div> 
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Guardar</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Add Precios' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    gasolinera: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        gasolinera: 1,
        diesel_1: this.gasolinera.precio_diesel,
        extra_1: this.gasolinera.precio_extra,
        super_1: this.gasolinera.precio_super,
        diesel_2: this.gasolinera.precio_diesel_2,
        extra_2: this.gasolinera.precio_extra_2,
        super_2: this.gasolinera.precio_super_2,
        diesel_3: this.gasolinera.precio_diesel_3,
        extra_3: this.gasolinera.precio_extra_3,
        super_3: this.gasolinera.precio_super_3,
        diesel_4: this.gasolinera.precio_diesel_4,
        extra_4: this.gasolinera.precio_extra_4,
        super_4: this.gasolinera.precio_super_4,
        diesel_5: this.gasolinera.precio_diesel_5,
        extra_5: this.gasolinera.precio_extra_5,
        super_5: this.gasolinera.precio_super_5,
        diesel_6: this.gasolinera.precio_diesel_6,
        extra_6: this.gasolinera.precio_extra_6,
        super_6: this.gasolinera.precio_super_6,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('maquinarias.storePrecios'))
    },
  },
}
</script>
